import React, { useEffect } from 'react';

import combinedActions from '~redux/combinedActions';
import { useAppDispatch, useAppSelector } from '~redux/hooks';
import { TGetDashboardProductInventoryFilters } from '~types/feat/dashboard';

import ActionButton from '~components/atoms/ActionButton';
import LabelledDropdown from '~components/atoms/LabelledDropdown';

import * as Styles from './_availableInventorySearchAndFilterBar.module.scss';

const AvailableInventorySearchAndFilterBar = () => {

    const dispatch = useAppDispatch();
    const filters = useAppSelector(state => state.dashboard.dashboardSilverProductInventoryFilters);
    const { allBranchAccess, branchCode } = useAppSelector(state => state.auth.userDetails);

    const setFilters = (inputFilters: TGetDashboardProductInventoryFilters) => dispatch(combinedActions.dashboardSetdashboardSilverProductInventoryFilters(inputFilters));

    const branchesList = useAppSelector(state => state.branch.allBranches);

    const branchOptions = branchesList.map((branch) => ({
        label: branch.branchName,
        value: branch.branchCode,
    }));

    useEffect(() => {
        if (branchesList.length === 0) return;

        if (!allBranchAccess) {
            const defaultBranch = branchesList.find(
                b => b.branchCode === branchCode
            );

            if (!defaultBranch) return;

            setFilters({
                ...filters,
                branchName: defaultBranch.branchName,
                branchCode: defaultBranch.branchCode,
            });
        }
    }, [branchesList]);

    const handleOnSearchBranch = (event: React.ChangeEvent<HTMLInputElement>) => {
        setFilters({
            ...filters,
            branchName: event.target.value,
            branchCode: branchesList.find((branch) => branch.branchName === event.target.value)?.branchCode || '',
        });
    };

    const getSelectedBranch = () => {
        if (!branchesList.length) return null;

        return !allBranchAccess
            ? branchesList.find(b => b.branchCode === branchCode)
            : branchesList[0];
    };

    const handleOnClear = () => {
        if (allBranchAccess) {
            setFilters({
                ...filters,
                branchName: '',
                branchCode: '',
            });
            return;
        }

        const defaultBranch = branchesList.find(
            b => b.branchCode === branchCode
        );

        if (!defaultBranch) return;

        setFilters({
            ...filters,
            branchName: defaultBranch.branchName,
            branchCode: defaultBranch.branchCode,
        });
    };

    const renderBranchOptions = () => {
        return (
            <>
                <LabelledDropdown
                    isFilter
                    label=''
                    placeholder='All Branches'
                    options={branchOptions}
                    value={filters.branchName}
                    onChange={handleOnSearchBranch}
                    // onSelectOption={handleOnSelectCustomer}
                    noOptionsMessage='No branch found'
                    autoComplete='off'
                    optionSelected={!!branchOptions.find((branch) => branch.label === filters.branchName)}
                    disabled={!allBranchAccess}
                />

                <ActionButton
                    label='Clear'
                    onClick={handleOnClear}
                    className={`${Styles['action-button']} ${Styles['is-red']}`}
                />
            </>
        );
    };

    return (
        <div className={Styles['dropdown-container']}>
            {renderBranchOptions()}
        </div>
    );
};

export default AvailableInventorySearchAndFilterBar;
